import React, {useState} from 'react';
import SkillButton from "../../project-position/SkillButton";
import {Dropdown, DropdownItem, DropdownToggle, DropdownMenu} from "reactstrap";
import useOuterClick from "../../../hooks/useOuterClick";
const SkillScoreItem = React.forwardRef(({ value, score, disabled, skill,onClick, valuePropName = 'self_score' }, ref) => (
    <DropdownItem
        ref={ref}
        key={'but' + value}
        active={String(skill?.[valuePropName]) === String(value)}
        tag={'span'}
        onClick={onClick}>
        <SkillButton
            isDisabled={disabled}
            name={score}
            selected={String(skill?.[valuePropName]) === String(value)}
        />
    </DropdownItem>
));

const SkillFormButton = React.forwardRef((
    {
        valuePropName = 'self_score',
        scoringOptions = laravel.talent_scoring_options,
        ...props
    }, ref) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(!dropdownOpen);
    const innerRef = useOuterClick(ev => {
        console.log("ev", ev);
        toggle();
    });

    const canRemove = !props.removeDisabled && !props.onlyEdit;
    const canEdit = !props.editDisabled && (props.onlyEdit || !props.removeDisabled);

    return (
        <div ref={ref} className={props.className} tabIndex={props.tabIndex}>
            <Dropdown direction={'down'} tag={'span'}
                      toggle={() => {
                          return !props.selected && toggle()
                      }}
                      isOpen={dropdownOpen}
                      className={props.noMatch ? 'unmatched-skill' : (props.unselected ? 'unselected-skill' : '')}>

                <DropdownToggle tag={'span'} onClick={props.selected ? event => event.preventDefault() : undefined}>
                    <div className={TB.mapClass('skill ', {
                        'unselected': props.unselected,
                        'selected': !props.unselected && dropdownOpen || props.skill.hasOwnProperty(valuePropName),
                        'highlighted': props.highlighted,
                        'disabled': props.disabled}
                    )}>

                        <p onClick={(event) => {
                            if(props.selected && canEdit) return toggle()
                        }} className="whitespace-nowrap">
                            {props.skill.name}
                        </p>


                        {canRemove && (
                            <React.Fragment>
                                <div className="s-divider"/>
                                <i onClick={(event) => {
                                    if(!dropdownOpen && props.selected) {
                                        return props.onChange({...props.skill, [valuePropName]: undefined});
                                    }
                                }} className={dropdownOpen ? 'fa fa-chevron-down' :
                                    (TB.isDefined(props.skill[valuePropName]) ? 'fa fa-minus': 'fa fa-plus')}/>
                            </React.Fragment>
                        )}

                    </div>

                    {TB.isDefined(props.skill[valuePropName]) && !dropdownOpen && (
                        <span onClick={() => {
                            if(props.selected && canEdit) return toggle()
                        }} className="skill-result skill">
                            <p>{scoringOptions ? scoringOptions[props.skill[valuePropName]] : props.skill[valuePropName]}</p>
                            {canEdit && <i className="fa fa-chevron-down"/>}
                        </span>
                    )}
                    {props.noMatch && !dropdownOpen && (
                        <span className="skill-result skill">
                            <p>No Experience</p>
                            {props.onChange && (
                                <i className="fas fa-plus-circle text-success"/>
                            )}
                        </span>
                    )}
                </DropdownToggle>

                {scoringOptions && (

                    <DropdownMenu tag={'span'} >
                        {Object.keys(scoringOptions).map((valueProp, i) => (
                            <SkillScoreItem
                                key={`skill-${props.skill.id}-item-${i}`}
                                valuePropName={valuePropName}
                                disabled={props.disabled}
                                skill={props.skill}
                                onClick={() => {
                                    props.onChange({...props.skill, [valuePropName]: valueProp});
                                    toggle();
                                }}
                                score={scoringOptions[valueProp]}
                                value={valueProp}/>
                        ))}
                    </DropdownMenu>
                )}
            </Dropdown>
        </div>
    );
});

export default SkillFormButton;